<div class="flex-column disclosure-box disclosure-box-content">
  <p *ngFor="let paragraph of paragraphs" [innerHtml]="paragraph"></p>
</div>